
import React, { useEffect, useRef } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

// core components
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footer/Footer.js";
import NotificationAlert from "react-notification-alert";


import routes from "routes.js";
import useGlobal from "store";

const Auth = (props) => {

  const [state] = useGlobal(
    state => state
  );

  const notifyRef = useRef(null);
  
  useEffect(() => {
    if(!state.auth) {
        return;
    }
  }, [state.auth]);
    
  useEffect(() => {
    if(!state.notification) {
        return;
    }
    notifyRef.current.notificationAlert(state.notification);
  }, [state.notification]);


  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };


    return (
      <>
        <NotificationAlert ref={notifyRef} />

        <AuthNavbar {...props} />
        <div className="wrapper wrapper-full-page">
          <div
            className="full-page section-image"
            filter-color="blue"
          >
            <Switch>
              {getRoutes(routes)}
              <Redirect from="/auth" to="/auth/login-page" />
            </Switch>
            <Footer fluid />
          </div>
        </div>
      </>
    );
  
}

export default Auth;
